import RoutePath from '@/utils/define/RoutePath'
import PageName from '@/utils/define/PageName'

export default [
	{
		name: '브랜드 관',
		path: RoutePath.Brand,
		pageName: PageName.List,
		category: 'brand',
	},
	{
		name: '찜 목록',
		path: RoutePath.MyPage.Wish,
		pageName: PageName.MyPage.Wish,
		category: 'wish',
		hidden: true, // 사용하지 않는 메뉴 (헤더에서 숨김)
	},
	{
		name: '이벤트',
		path: RoutePath.CsCenter.EventManagement,
		pageName: PageName.CsCenter.EventManagement,
		category: 'event',
	},
	{
		name: '고객센터',
		path: RoutePath.CsCenter.QuestionManagement,
		pageName: PageName.CsCenter.QuestionManagement,
		category: 'service',
		hidden: true, // 푸터에 고객센터가 있어 헤더에서는 숨김
	},
]
